<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Medicine Dispensing Visit</title>
  <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet">
  <style>
    .custom-button {
      background-color: #673AB7;
      color: white;
    }
    .radio-group {
      display: flex;
      gap: 10px;
    }
    .radio-label {
      display: flex;
      align-items: center;
    }
    .form-container {
      max-height: 500px;
      overflow-y: auto;
      padding-right: 15px;
    }
  </style>
</head>
<body>
  <div class="container-fluid p-0">
    <app-header></app-header>
    <div class="row m-0 g-0">
      <div class="col-md-3 p-0">
        <app-folders></app-folders>
      </div>
  
      <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important;">
        <div class="card" style="height: 1000px;">
          <div class="card-body">
            <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
              <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
            </div>
           
           
<!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: 5px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
  </div>
</div>

            <!-- Medicine Dispensing Visit Date Form -->
            <div *ngIf="formName === 'medicine-dispensing-visit-date'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Medicine Dispensing Visit Date</h5>
                  <button type="button" class="btn custom-button">Create Field</button>
                </div>
                <div class="card-body scrollable-container">
                  <form (ngSubmit)="submitForm()">
                    <div class="form-group">
                      <label for="visitNo">1. Medicine Dispensing Visit No:</label>
                      <input type="number" id="visitNo" class="form-control" [(ngModel)]="formData.visitNo" name="visitNo" required>
                    </div>
                    <div class="form-group">
                      <label for="visitDate">2. Date of Visit:</label>
                      <input type="date" id="visitDate" class="form-control" [(ngModel)]="formData.visitDate" name="visitDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Vital Signs Form -->
            <div *ngIf="formName === 'medicine-vital-signs'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Vital Signs</h5>
                  <button type="button" class="btn custom-button" (click)="createField()">Create Field</button>
                </div>
                <div class="card-body">
                  <form (ngSubmit)="submitForm()">
                    <div class="form-group">
                      <label>1. Was Vital Signs evaluation performed?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="vitalYes" name="vitalSigns" value="yes" [(ngModel)]="formData.vitalSigns" (change)="checkVitalSigns()" required >
                          <label for="vitalYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="vitalNo" name="vitalSigns" value="no" [(ngModel)]="formData.vitalSigns" (change)="checkVitalSigns()" required>
                          <label for="vitalNo" class="ml-1">No</label>
                        </label>
                      </div>
                       <!-- Show the button only when "Yes" is selected -->
                    <div class="mt-3" *ngIf="formData.vitalSigns === 'yes'">
                      <button type="button" class="btn btn-success" (click)="navigateToVitalSigns()">
                        Add Vital Signs Data
                      </button>
                    </div>
                       <div class="mt-3" *ngIf="formData.vitalSigns === 'no'">
                      <label>Comments:</label>
                      <textarea  class="form-control" [(ngModel)]="formData.vitalSignsComments" name="vitalSignsComments" #vitalCommentsRef="ngModel" required></textarea>
                      <div *ngIf="vitalComments.invalid && vitalComments.touched" class="text-danger">
                        Comments are required when 'No' is selected.
                      </div>
                    </div>
                    </div>
                   
                 
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Pregnancy Declaration Form
            <div *ngIf="formName === 'medicine-pregnancy-declaration'">
              <div class="card mt-4" style="border: 2px solid #673AB7; border-radius: 8px; padding: 0px; background-color: #fff;">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Pregnancy Declaration</h5>
                  <button type="button" class="btn custom-button">Create Field</button>
                </div>
                <div *ngIf = "gender !== 'Male'" class="card-body">
                  <form (ngSubmit)="submitForm()">
                    <div class="form-group">
                      <label>1. Ask the subject “Are you currently pregnant?”</label>
                      <select class="form-control"  [(ngModel)]="formData.pregnancyStatus" name="pregnancyStatus" required>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        <option value="na">N/A</option>
                      </select>
                    </div>
                    <div class="text-end">
                      <button type="button" class="btn custom-button">Back</button>
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div> -->
            <div *ngIf="formName === 'medicine-pregnancy-declaration'" class="card mt-4" >
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="m-0">URINE PREGNANCY TEST</h5>
                <button type="button" class="btn custom-button">Create Field</button>
              </div>
  
              <div *ngIf = "gender !== 'Male'"  class="card-body">
                <form (ngSubmit)="submitForm()">
                   <!-- Date of Last Menstrual Period (LMP) -->
        <div class="form-group">
          <label>Date of Last Menstrual Period (LMP)</label>
          <input type="date" class="form-control" [(ngModel)]="formData.lmpDate" name="lmpDate" [max]="todayDate" required />
        </div>
  
        <!-- Was Urine Pregnancy Test (UPT) done? -->
        <div class="form-group mt-2">
          <label>Was Urine Pregnancy Test (UPT) done?</label>
          <select class="form-control" [(ngModel)]="formData.uptDone" name="uptDone" (change)="handleUptDoneChange()" required>
            <option value="">Select</option>
            <option value="YES">Yes</option>
            <option value="NO">No</option>
            <option value="NA">Not Applicable</option>
          </select>
             <!-- UPT Result - Shown only if UPT Done is YES -->
        <div class="mt-4" *ngIf="formData.uptDone === 'YES'">
          <label>UPT Result</label>
          <select class="form-control" [(ngModel)]="formData.uptResult" name="uptResult" (change)="handleUptResultChange()" required>
            <option value="">Select</option>
            <option value="Positive">Positive</option>
            <option value="Negative">Negative</option>
            <option value="Referred for confirmation">Referred for confirmation</option>
          </select>
        </div>
        </div>
  
     
        <div class="text-end">
          <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
          <button type="submit" class="btn custom-button">Submit</button>
        </div>
      </form>
    </div>
  </div>
  

           <!-- Anthropometric Data Form -->
            <div *ngIf="formName === 'medicine-anthropometric-data'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Anthropometric Data</h5>
                   <button type="button" class="btn custom-button">Create Field</button>
                </div>
                <div class="card-body">
                  <form (ngSubmit)="validateForm()" #form="ngForm">
                    <!-- Weight Field -->
                    <div class="form-group">
                      <label for="weight">1. Weight (kg):</label>
                      <input type="text" id="weight" 
                             [(ngModel)]="formData.weight" 
                             name="weight" 
                             class="form-control" 
                             placeholder="000.00 kg" 
                             pattern="^\d{3}\.\d{2}$" 
                             (input)="calculateBMI()" 
                             #weight="ngModel">
                    </div>
                    <!-- Height Field -->
                    <div class="form-group mt-2">
                      <label for="height">2. Height (m):</label>
                      <input type="text" id="height" 
                            [(ngModel)]="formData.height" 
                            name="height" 
                            class="form-control" 
                            placeholder="00.00 m" 
                            pattern="^\d{2}\.\d{2}$" 
                            (input)="calculateBMI()" 
                            #height="ngModel">
                    </div>
                    <!-- Waist Circumference Field -->
                  <div class="form-group mt-2">
                    <label for="waist">3. Waist Circumference (cm) (Part of IDRS Assessment):</label>
                    <input type="text" id="waist" 
                          [(ngModel)]="formData.waistCircumference" 
                          name="waistCircumference" 
                          class="form-control" 
                          placeholder="000.00 cm" 
                          pattern="^\d{3}\.\d{2}$" 
                          #waist="ngModel">
                  </div>
                    <div class="form-group">
                      <label for="weightLossPrevious">4. Weight-loss from previous visit (kg):</label>
                      <input type="number" id="weightLossPrevious" [(ngModel)]="formData.weightLossPrevious" name="weightLossPrevious" class="form-control" placeholder="000.00 kg" pattern="^\d{3}\.\d{2}$"  #weightLossPrevious>
                    </div>
                    <div class="form-group">
                      <label for="weightLossBaseline">5. Weight-loss since baseline visit (kg):</label>
                      <input type="number" id="weightLossBaseline" [(ngModel)]="formData.weightLossBaseline" name="weightLossBaseline" class="form-control" placeholder="000.00 kg" pattern="^\d{3}\.\d{2}$" #weightLossBaseline >
                    </div>
                    <div class="form-group">
                      <label for="waistDifferencePrevious">6. Difference in Waist circumference from previous visit (cm):</label>
                      <input type="number" id="waistDifferencePrevious" [(ngModel)]="formData.waistDifferencePrevious" name="waistDifferencePrevious" class="form-control" placeholder="000.00 cm" pattern="^\d{3}\.\d{2}$" #waistDifferencePrevious >
                    </div>
                    <div class="form-group">
                      <label for="waistDifferenceBaseline">7. Difference in Waist circumference since baseline visit (cm):</label>
                      <input type="number" id="waistDifferenceBaseline" [(ngModel)]="formData.waistDifferenceBaseline" name="waistDifferenceBaseline" class="form-control" placeholder="000.00 cm" pattern="^\d{3}\.\d{2}$" waistDifferenceBaseline >
                    </div>
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Study Product Retrieval Form -->
            <div *ngIf="formName === 'medicine-product-retrieval'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Study Product Retrieval</h5>
                  <button type="button" class="btn custom-button" (click)="createField()">Create Field</button>
                </div>
                <div class="card-body">
                  <form (ngSubmit)="submitForm()" >
                    <div class="form-group">
                      <label>Was the Study Product retrieved from subject as per protocol?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="studyYes" name="productRetrieved" value="yes"  [(ngModel)]="formData.productRetrieved" required> 
                          <label for="studyYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="studyNo"name="productRetrieved" value="no"  [(ngModel)]="formData.productRetrieved" required>
                          <label for="studyNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div class="mt-3" *ngIf="formData.productRetrieved === 'no'">
                      <label >Comments:</label>
                      <textarea  class="form-control" [(ngModel)]="formData.studyComments" name="studyComments"></textarea>
                    </div>
                    </div>
                    
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Study Product Accountability Form -->
            <div *ngIf="formName === 'medicine-product-accountability'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Study Product Accountability</h5>
                  <button type="button" class="btn custom-button">Create Field</button>
                </div>
                <div class="card-body form-container">
                  <form (ngSubmit)="validateForm()" #form="ngForm">
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">i. Asana Churna herbal drink</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="asanaDispensedPrevious">Total Number of sachets/boxes dispensed in previous visit:</label>
                      <input type="number" id="asanaDispensedPrevious" class="form-control" [(ngModel)]="formData.asanaDispensedPrevious" name="asanaDispensedPrevious" required>
                    </div>
                    <div class="form-group">
                      <label for="asanaQuantityPrevious">Total Study Product quantity dispensed in previous visit (g):</label>
                      <input type="number" id="asanaQuantityPrevious" class="form-control" [(ngModel)]="formData.asanaQuantityPrevious" name="asanaQuantityPrevious" placeholder="000g" pattern="^\d{3}$" required #asanaQuantityPrevious="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="asanaRetrievedCurrent">Total Number of sachets/boxes retrieved in current visit:</label>
                      <input type="number" id="asanaRetrievedCurrent" class="form-control" [(ngModel)]="formData.asanaRetrievedCurrent" name="asanaRetrievedCurrent" required>
                    </div>
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">ii. Triphala tablet</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="triphalaDispensedPrevious">Total Number of sachets/boxes dispensed in previous visit:</label>
                      <input type="number" id="triphalaDispensedPrevious" class="form-control" [(ngModel)]="formData.triphalaDispensedPrevious" name="triphalaDispensedPrevious" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaQuantityPrevious">Total Study Product quantity dispensed in previous visit (g):</label>
                      <input type="number" id="triphalaQuantityPrevious" class="form-control" [(ngModel)]="formData.triphalaQuantityPrevious" name="triphalaQuantityPrevious" placeholder="000g" pattern="^\d{3}$" required #triphalaQuantityPrevious="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="triphalaRetrievedCurrent">Total Number of sachets/boxes retrieved in current visit:</label>
                      <input type="number" id="triphalaRetrievedCurrent" class="form-control" [(ngModel)]="formData.triphalaRetrievedCurrent" name="triphalaRetrievedCurrent" required>
                    </div>
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">iii. Yava Churna</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="yavaDispensedPrevious">Total Number of sachets/boxes dispensed in previous visit:</label>
                      <input type="number" id="yavaDispensedPrevious" class="form-control" [(ngModel)]="formData.yavaDispensedPrevious" name="yavaDispensedPrevious" required>
                    </div>
                    <div class="form-group">
                      <label for="yavaQuantityPrevious">Total Study Product quantity dispensed in previous visit (g):</label>
                      <input type="number" id="yavaQuantityPrevious" class="form-control" [(ngModel)]="formData.yavaQuantityPrevious" name="yavaQuantityPrevious" placeholder="000g" pattern="^\d{3}$" required #yavaQuantityPrevious="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="yavaRetrievedCurrent">Total Number of sachets/boxes retrieved in current visit:</label>
                      <input type="number" id="yavaRetrievedCurrent" class="form-control" [(ngModel)]="formData.yavaRetrievedCurrent" name="yavaRetrievedCurrent" required>
                    </div>
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Study Product Compliance Form -->
            <div *ngIf="formName === 'medicine-product-compliance'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Study Product Compliance</h5>
                  <button type="button" class="btn custom-button" (click)="createField()">Create Field</button>
                </div>
                <div class="card-body form-container">
                  <form (ngSubmit)="validateForm()" #form="ngForm">
                    <!-- Asana Churna Section -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">i. Asana Churna herbal drink</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label>Is the subject compliant with the usage of Study Product as per the protocol?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="studycomplainceYes" name="asanaCompliance" value="yes" [(ngModel)]="formData.asanaCompliance" required> 
                          <label for="studycomplainceYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="studycomplainceNo" name="asanaCompliance" value="no"  [(ngModel)]="formData.asanaCompliance" required> 
                          <label for="studycomplainceNo" class="ml-1">No</label>
                        </label>
                      </div>
                       <div class="mt-3" *ngIf="formData.asanaCompliance === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea class="form-control" [(ngModel)]="formData.studyComplianceComments" name="studyComplianceComments"></textarea>
                    </div>
                    </div>
                   
                    <div class="form-group">
                      <label for="asanaFirstDate">Date of first Study Product consumed:</label>
                      <input type="date" id="asanaFirstDate" class="form-control" [(ngModel)]="formData.asanaFirstDate" name="asanaFirstDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="asanaLastDate">Date of last Study Product consumed:</label>
                      <input type="date" id="asanaLastDate" class="form-control" [(ngModel)]="formData.asanaLastDate" name="asanaLastDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="asanaConsumed">Total quantity of Study Product consumed (g):</label>
                      <input type="number" id="asanaConsumed" class="form-control" [(ngModel)]="formData.asanaConsumed" name="asanaConsumed" placeholder="000g" pattern="^\d{3}$" required (input)="calculateCompliance('asana')" #asanaConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="asanaIdealConsumed">Total quantity of Study Product should ideally be consumed by subject (g):</label>
                      <input type="number" id="asanaIdealConsumed" class="form-control" [(ngModel)]="formData.asanaIdealConsumed" name="asanaIdealConsumed" placeholder="000g"  pattern="^\d{3}$"  required (input)="calculateCompliance('asana')" #asanaIdealConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="asanaMissed">Total quantity missed:</label>
                      <input type="number" id="asanaMissed" class="form-control" [(ngModel)]="formData.asanaMissed" name="asanaMissed" placeholder="XXX" required>
                    </div>
                    <div class="form-group">
                      <label for="asanaCompliancePercentage">Compliance (%):</label>
                      <input type="text" id="asanaCompliancePercentage" class="form-control" [(ngModel)]="formData.asanaCompliancePercentage" name="asanaCompliancePercentage"  readonly>
                    </div>
            
                    <!-- Triphala Tablet Section -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">ii. Triphala tablet</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label>Is the subject compliant with the usage of Study Product as per the protocol?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="triphalaComplainceYes" name="triphalaCompliance" value="yes" [(ngModel)]="formData.triphalaCompliance" required>
                          <label for="triphalaComplainceYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="triphalaComplainceNo" name="triphalaCompliance" value="no" [(ngModel)]="formData.triphalaCompliance" required>
                          <label for="triphalaComplainceNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div class="mt-3" *ngIf="formData.triphalaCompliance === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea  class="form-control" [(ngModel)]="formData.triphalaComplianceComments" name="triphalaComplianceComments"></textarea>
                    </div>
                    </div>
                    
                    <div class="form-group">
                      <label for="triphalaFirstDate">Date of first Study Product consumed:</label>
                      <input type="date" id="triphalaFirstDate" class="form-control" [(ngModel)]="formData.triphalaFirstDate" name="triphalaFirstDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaLastDate">Date of last Study Product consumed:</label>
                      <input type="date" id="triphalaLastDate" class="form-control" [(ngModel)]="formData.triphalaLastDate" name="triphalaLastDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaConsumed">Total quantity of Study Product consumed (g):</label>
                      <input type="number" id="triphalaConsumed" class="form-control" [(ngModel)]="formData.triphalaConsumed" name="triphalaConsumed"  placeholder="000g"  pattern="^\d{3}$"  required (input)="calculateCompliance('triphala')" #triphalaConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="triphalaIdealConsumed">Total quantity of Study Product should ideally be consumed by subject (g):</label>
                      <input type="number" id="triphalaIdealConsumed" class="form-control" [(ngModel)]="formData.triphalaIdealConsumed" name="triphalaIdealConsumed" placeholder="000g" pattern="^\d{3}$" required (input)="calculateCompliance('triphala')" #triphalaIdealConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="triphalaMissed">Total quantity missed:</label>
                      <input type="number" id="triphalaMissed" class="form-control" [(ngModel)]="formData.triphalaMissed" name="triphalaMissed" placeholder="XXX" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaCompliancePercentage">Compliance (%):</label>
                      <input type="text" id="triphalaCompliancePercentage" class="form-control" [(ngModel)]="formData.triphalaCompliancePercentage" name="triphalaCompliancePercentage" readonly>
                    </div>
            
                    <!-- Yava Churna Section -->
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">iii. Yava Churna</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label>Is the subject compliant with the usage of Study Product as per the protocol?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="yavaComplainceYes"  name="yavaCompliance" value="yes" [(ngModel)]="formData.yavaCompliance" required > 
                          <label for="yavaComplainceYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input type="radio"  id="yavaComplainceNo" name="yavaCompliance" value="no" [(ngModel)]="formData.yavaCompliance" required > 
                          <label for="yavaComplainceNo" class="ml-1">No</label>
                        </label>
                      </div>
                       <div class="mt-3" *ngIf="formData.yavaCompliance === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea id="comments" class="form-control" [(ngModel)]="formData.yavaComplianceComments" name="yavaComplianceComments"></textarea>
                    </div>
                    </div>
                   
                    <div class="form-group">
                      <label for="yavaFirstDate">Date of first Study Product consumed:</label>
                      <input type="date" id="yavaFirstDate" class="form-control" [(ngModel)]="formData.yavaFirstDate" name="yavaFirstDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="yavaLastDate">Date of last Study Product consumed:</label>
                      <input type="date" id="yavaLastDate" class="form-control"  [(ngModel)]="formData.yavaLastDate" name="yavaLastDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="form-group">
                      <label for="yavaConsumed">Total quantity of Study Product consumed (g):</label>
                      <input type="number" id="yavaConsumed" class="form-control" [(ngModel)]="formData.yavaConsumed" name="yavaConsumed" placeholder="000g" pattern="^\d{3}$" required (input)="calculateCompliance('yava')" #yavaConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="yavaIdealConsumed">Total quantity of Study Product should ideally be consumed by subject (g):</label>
                      <input type="number" id="yavaIdealConsumed" class="form-control" [(ngModel)]="formData.yavaIdealConsumed" name="yavaIdealConsumed" placeholder="000g"  pattern="^\d{3}$"  required (input)="calculateCompliance('yava')" #yavaIdealConsumed="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="yavaMissed">Total quantity missed:</label>
                      <input type="number" id="yavaMissed" class="form-control" [(ngModel)]="formData.yavaMissed" name="yavaMissed" required>
                    </div>
                    <div class="form-group">
                      <label for="yavaCompliancePercentage">Compliance (%):</label>
                      <input type="text" id="yavaCompliancePercentage" class="form-control" [(ngModel)]="formData.yavaCompliancePercentage" name="yavaCompliancePercentage"  readonly>
                    </div>
            
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Study Product Dispensing Record Form -->
            <div *ngIf="formName === 'medicine-product-dispensing-record'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Study Product Dispensing Record</h5>
                  <button type="button" class="btn custom-button" (click)="createField()">Create Field</button>
                </div>
                <div class="card-body form-container">
                  <form (ngSubmit)="validateForm()" #form="ngForm">
                    <div class="form-group">
                      <label>Were all the Study Products dispensed to the subject as per protocol?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="dispensedYes" name="dispensedProtocol" value="yes" [(ngModel)]="formData.dispensedProtocol" required> 
                          <span>Yes</span>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="dispensedNo" name="dispensedProtocol" value="no"  [(ngModel)]="formData.dispensedProtocol" required  > 
                          <span>No</span>
                        </label>
                      </div>
                       <div class="mt-3" *ngIf="formData.dispensedProtocol === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea class="form-control" [(ngModel)]="formData.dispensedProtocolComments" name="dispensedProtocolComments"></textarea>
                    </div>
                    </div>
                   
                    <div class="form-group">
                      <label>Was the Daily Product Consumption Log given to the subject?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="guideYes" name="logGiven" value="yes" [(ngModel)]="formData.logGiven" required >
                          <span>Yes</span>
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="guideNo" name="logGiven" value="no" [(ngModel)]="formData.logGiven" required >
                          <span>No</span>
                        </label>
                      </div>
                       <div class="mt-3" *ngIf="formData.logGiven === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea id="comments" class="form-control" [(ngModel)]="formData.logGivenComments" name="logGivenComments"></textarea>
                    </div>
                    </div>
                   
                    <div class="form-group">
                      <label for="dispensingDate">Date of dispensing of the Study Products:</label>
                      <input type="date" id="dispensingDate"  class="form-control" [(ngModel)]="formData.dispensingDate" name="dispensingDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">i. Asana Churna herbal drink</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="asanaDispensedCurrent">Total Number of sachets/boxes dispensed in this visit:</label>
                      <input type="number" id="asanaDispensedCurrent"  class="form-control" [(ngModel)]="formData.asanaDispensedCurrent" name="asanaDispensedCurrent" required>
                    </div>
                    <div class="form-group">
                      <label for="asanaQuantityCurrent">Total Study Product quantity dispensed in this visit (g):</label>
                      <input type="number" id="asanaQuantityCurrent" class="form-control" [(ngModel)]="formData.asanaQuantityCurrent" name="asanaQuantityCurrent" placeholder="000g"  pattern="^\d{3}$"  required #asanaQuantityCurrent="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="asanaBatch">Batch Number:</label>
                      <input type="number" id="asanaBatch" class="form-control" [(ngModel)]="formData.asanaBatch" name="asanaBatch"  required>
                    </div>
                    <div class="form-group">
                      <label for="asanaExpiry">Date of Expiry:</label>
                      <input type="date" id="asanaExpiry" class="form-control" [(ngModel)]="formData.asanaExpiry" name="asanaExpiry" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">ii. Triphala tablet</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="triphalaDispensedCurrent">Total Number of sachets/boxes dispensed in this visit:</label>
                      <input type="number" id="triphalaDispensedCurrent" class="form-control" [(ngModel)]="formData.triphalaDispensedCurrent" name="triphalaDispensedCurrent" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaQuantityCurrent">Total Study Product quantity dispensed in this visit (g):</label>
                      <input type="number" id="triphalaQuantityCurrent" class="form-control" [(ngModel)]="formData.triphalaQuantityCurrent" name="triphalaQuantityCurrent" placeholder="000g"  pattern="^\d{3}$"  required #triphalaQuantityCurrent="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="triphalaBatch">Batch Number:</label>
                      <input type="number" id="triphalaBatch" class="form-control" [(ngModel)]="formData.triphalaBatch" name="triphalaBatch" required>
                    </div>
                    <div class="form-group">
                      <label for="triphalaExpiry">Date of Expiry:</label>
                      <input type="date" id="triphalaExpiry" class="form-control" [(ngModel)]="formData.triphalaExpiry" name="triphalaExpiry" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="m-0">iii. Yava Churna</h5>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="yavaDispensedCurrent">Total Number of sachets/boxes dispensed in this visit:</label>
                      <input type="number" id="yavaDispensedCurrent" class="form-control" [(ngModel)]="formData.yavaDispensedCurrent" name="yavaDispensedCurrent" required>
                    </div>
                    <div class="form-group">
                      <label for="yavaQuantityCurrent">Total Study Product quantity dispensed in this visit (g):</label>
                      <input type="number" id="yavaQuantityCurrent" class="form-control"[(ngModel)]="formData.yavaQuantityCurrent" name="yavaQuantityCurrent"  placeholder="000g"  pattern="^\d{3}$"  required #yavaQuantityCurrent="ngModel">
                    </div>
                    <div class="form-group">
                      <label for="yavaBatch">Batch Number:</label>
                      <input type="number" id="yavaBatch" class="form-control" [(ngModel)]="formData.yavaBatch" name="yavaBatch"  required>
                    </div>
                    <div class="form-group">
                      <label for="yavaExpiry">Date of Expiry:</label>
                      <input type="date" id="yavaExpiry" class="form-control" [(ngModel)]="formData.yavaExpiry" name="yavaExpiry" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            
            <!-- Review of Adverse Events and Concomitant Medication Form -->
            <div *ngIf="formName === 'medicine-adverse-events'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Review of Adverse Events and Concomitant Medication</h5>
                  <button type="button" class="btn custom-button">Create Field</button>
                </div>
                <div class="card-body">
                  <form (ngSubmit)="submitForm()">
                    <div class="form-group">
                      <label>Did the subject experience any adverse event since last visit?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="aeYes" name="adverseEvent" value="yes" [(ngModel)]="formData.adverseEvent" required> Yes
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="aeNo" name="adverseEvent" value="no" [(ngModel)]="formData.adverseEvent" required> No
                        </label>
                      </div>
                             <!-- Show the button only when "Yes" is selected for Adverse Events -->
              <div class="mt-3" *ngIf="formData.adverseEvent === 'yes'">
                <button type="button" class="btn btn-success" (click)="navigateToAdverseEvents()">
                  Add Adverse Event Data
                </button>
              </div>
                    </div>

              
                    <div class="form-group">
                      <label>Did the subject take any new or change in concomitant medications since last visit?</label>
                      <div class="radio-group">
                        <label class="radio-label">
                          <input type="radio" id="medYes" name="concomitantMedication" value="yes" [(ngModel)]="formData.concomitantMedication" required> Yes
                        </label>
                        <label class="radio-label">
                          <input type="radio" id="medNo" name="concomitantMedication" value="no" [(ngModel)]="formData.concomitantMedication" required> No
                        </label>
                      </div>
                       <!-- Show the button only when "Yes" is selected -->
                    <div class="mt-3" *ngIf="formData.concomitantMedication === 'yes'">
                      <button type="button" class="btn btn-success" (click)="navigateToConcomitantMedication()">
                        Add Concomitant Data
                      </button>
                    </div>
                    </div>
                    
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- End of Visit Form -->
            <div *ngIf="formName === 'medicine-end-visit'">
              <div class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">End of Visit</h5>
                </div>
                <div class="card-body">
                  <form (ngSubmit)="submitForm()">
                    <div class="form-group">
                      <label for="investigatorSignature">Principal Investigator’s Signature:</label>
                      <input type="text" id="investigatorSignature" class="form-control" [(ngModel)]="formData.investigatorSignature" name="investigatorSignature" placeholder="Digital signature" required>
                    </div>
                    <div class="form-group">
                      <label for="endDate">Date:</label>
                      <input type="date" id="endDate" class="form-control" [(ngModel)]="formData.endDate" name="endDate" [min]="screeningMinDate"  [max]="todayDate" required>
                    </div>
                    <div class="text-end">
                      <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                      <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
  <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.9.2/dist/umd/popper.min.js"></script>
  <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
  <script>
    // JavaScript to handle dynamic form behavior
    document.addEventListener('DOMContentLoaded', function () {
      const vitalSignsRadio = document.querySelectorAll('input[name="vitalSigns"]');
      const vitalComments = document.getElementById('vitalComments');

      vitalSignsRadio.forEach(radio => {
        radio.addEventListener('change', function () {
          if (this.value === 'no') {
            vitalComments.style.display = 'block';
          } else {
            vitalComments.style.display = 'none';
          }
        });
      });
    });
  </script>
</body>
</html>